import * as React from 'react';
import {
  Box, 
  Button,
  Typography,
}from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import {  styled } from '@mui/system';
import * as EzDateUtils from 'utils/EzDateUtils'
/**
 * 한줄 영역 컴포넌트
 */
const EzRow = styled('div')({
  display:'flex', 
  flexDirection : 'row',
  flex:1,
  marginBottom:3,
});
/**
 * 항목명 
 */
const EzTitle = styled('div')({
  color: 'darkslategray',
  backgroundColor: '#e8e8e8',
  padding: 8,
  textAlign:'center',
  borderRadius: 4,
  width:'100px'
});
/**
 * 항목 데이터 
 */
const EzContent = styled('div')({
  color: 'darkslategray',
  padding: 8,
  borderRadius: 4,
  flex:1, 
});

/*
 * Module - MemberDetail.js
 *
 * Description : 회원 상세 정보 조회 화면입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Wed Jun 29 2022
 * Copyright (c) 2022 Renewhouse corp
 */
const MemberDetail = () => {

	const {state} = useLocation();
  const navigate = useNavigate();
  return (
    <>
      <Typography variant="h5" color="text.primary" sx={{mb:5, mt:5}}>회원 상세보기</Typography>
      <EzRow>
        <EzRow>
          <EzTitle>아이디</EzTitle>
          <EzContent>{state[0].ezCompanyId}</EzContent>
        </EzRow>
        <EzRow>
          <EzTitle>상호</EzTitle>
          <EzContent>{state[0].compName}</EzContent>
        </EzRow>
      </EzRow>
      <EzRow>
        <EzRow>
          <EzTitle>대표자</EzTitle>
          <EzContent>{state[0].ceoName}</EzContent>
        </EzRow>
        <EzRow>
          <EzTitle>사업자번호</EzTitle>
          <EzContent>{state[0].compSsn}</EzContent>
        </EzRow>
      </EzRow> 
      <EzRow>
        <EzRow>
          <EzTitle>전화번호</EzTitle>
          <EzContent>{state[0].compTelNo}</EzContent>
        </EzRow>
        <EzRow>
          <EzTitle>팩스번호</EzTitle>
          <EzContent>{state[0].compFaxNo}</EzContent>
        </EzRow>
      </EzRow>  
      <EzRow>
        <EzRow>
          <EzTitle>우편번호</EzTitle>
          <EzContent>{state[0].postNo}</EzContent>
        </EzRow>
        {/* <EzRow>
          <EzTitle>팩스번호</EzTitle>
          <EzContent>{state[0].compFaxNo}</EzContent>
        </EzRow> */}
      </EzRow>  
      <EzRow>
        <EzRow>
          <EzTitle>주소</EzTitle>
          <EzContent>{state[0].compAddress} {state[0].compSubaddress}</EzContent>
        </EzRow>
        {/* <EzRow>
          <EzTitle>팩스번호</EzTitle>
          <EzContent>{state[0].compFaxNo}</EzContent>
        </EzRow> */}
      </EzRow>  
      <EzRow>
        <EzRow>
          <EzTitle>업태</EzTitle>
          <EzContent>{state[0].compBizType}</EzContent>
        </EzRow>
        <EzRow>
          <EzTitle>종목</EzTitle>
          <EzContent>{state[0].compItemType}</EzContent>
        </EzRow>
      </EzRow>  
      <EzRow>
        <EzRow>
          <EzTitle>사용만기</EzTitle>
          <EzContent>{EzDateUtils.dateFormatting(state[0].licenceEndDate)}</EzContent>
        </EzRow>
        <EzRow>
          <EzTitle>등록일</EzTitle>
          <EzContent>{EzDateUtils.dateFormatting(state[0].regdate)}</EzContent>
        </EzRow>
      </EzRow>  
      <EzRow>
        <EzRow>
          <EzTitle>접속일자</EzTitle>
          <EzContent>{EzDateUtils.dateFormatting(state[0].lastLogin)}</EzContent>
        </EzRow>
        {/* <EzRow>
          <EzTitle>등록일</EzTitle>
          <EzContent>{state[0].regdate}</EzContent>
        </EzRow> */}
      </EzRow>  
      <Box sx={{display:'flex', justifyContent:'flex-end'}}>
        <Button
          variant="outlined"
          sx={{ ml: 2 }}
          onClick={()=>{navigate(-1)}}
        >
          목록으로
        </Button>
      </Box>
    </>
  );
}

export default MemberDetail;